import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const updateMessageReaction = gql`
  mutation UpdateMessageReactionMutation(
    $messageId: Int!
    $reactionType: ReactionType!
    $add: Boolean!
  ) {
    toggleMessageReaction(
      input: { messageId: $messageId, reactionType: $reactionType, adding: $add }
    ) {
      message {
        id
        meta {
          id
          reactions {
            ...Reaction
          }
        }
      }
    }
  }

  ${Fragments.chat.reaction}
`;

export const sendMessage = gql`
  mutation SendMessageMutation(
    $channelSlug: String!
    $content: String!
    $urgent: Boolean
    $attachments: [NewAttachment]
    $uuid: String!
  ) {
    createMessage(
      input: {
        channelSlug: $channelSlug
        message: {
          type: TEXT
          content: $content
          isImportant: $urgent
          meta: { uuid: $uuid, attachments: $attachments }
        }
      }
    ) {
      recentMessageCount
      message {
        ...ChatMessage
      }
      pendingUsers {
        ...ShortUser
      }
    }
  }

  ${Fragments.chat.message}
  ${Fragments.user.short}
`;

export const editMessage = gql`
  mutation EditMessageMutation($messageId: Int!, $content: String!) {
    messages {
      edit(messageId: $messageId, content: $content) {
        ...ChatMessage
      }
    }
  }

  ${Fragments.chat.message}
`;

export const deleteMessage = gql`
  mutation DeleteMessageMutation($messageId: Int!) {
    deleteMessage(input: { messageId: $messageId }) {
      message {
        ...ChatMessage
      }
    }
  }

  ${Fragments.chat.message}
`;

export const updateIsTyping = gql`
  mutation UpdateIsTypingMutation($channelSlug: String!) {
    userIsTyping(input: { channelSlug: $channelSlug }) {
      success
    }
  }
`;

export const markMessagesAsRead = gql`
  mutation MarkChannelMessagesAsReadMutation($channelSlug: String!, $readAt: DateTime!) {
    markChannelMessagesRead(input: { channelSlug: $channelSlug, readAt: $readAt }) {
      channel {
        ...ChannelUnreadCounts
        readAt
      }
    }
  }

  ${Fragments.channel.unreadCounts}
`;

export const sendToPendingUsers = gql`
  mutation SendMessageToPendingUsers($messageId: Int!) {
    sendSmsToPendingUsers(input: { messageId: $messageId }) {
      success
    }
  }
`;
